import getLocationFromApi from './getLocationApi';
import notifyNewrelic from './notifyNewrelic';

const onPositionFailed = (err, shouldLogNewrelic, secondaryLocationApi, cacheDuration) => {
  let message = '';

  switch (err.code) {
    case 1:
      message = 'Location permission denied from browser';
      notifyNewrelic(shouldLogNewrelic, 'Denied', 'Browser', message);
      break;

    case 2:
      message = 'Position unavailable from browser';
      notifyNewrelic(shouldLogNewrelic, 'Position Unavailable', 'Browser', message);
      break;

    case 3:
      message = 'Location prompt timedout on browser';
      notifyNewrelic(shouldLogNewrelic, 'Timed Out', 'Browser', message);
      break;

    case 4:
      message = 'Error Occured in Geocoding api';
      notifyNewrelic(shouldLogNewrelic, 'Error', 'GeoCoding_Api', message);
      break;

    case 5:
      message = 'Geolocation Api unvailable';
      notifyNewrelic(shouldLogNewrelic, 'Unavailable', 'GeoCoding_Api', message);
      break;
    // case 6:
    //   message = 'No Location data recieved from secondary location Api';
    //   notifyNewrelic(shouldLogNewrelic, 'No Data', 'Eleanor_Api', message);
    //   break;
    // case 7:
    //   message = 'Error occured while calling secondary location Api';
    //   notifyNewrelic(shouldLogNewrelic, 'Error', 'Eleanor_Api', message);
    //   break;

    case 0:
    default:
      message = 'Unknown error on browser';
      notifyNewrelic(shouldLogNewrelic, 'Unknown Error', 'Browser', message);
  }

  if (secondaryLocationApi) return getLocationFromApi(secondaryLocationApi, cacheDuration);
  const positionEvent = new CustomEvent('location', {
    detail: {
      success: false,
      message
    }
  });
  document.dispatchEvent(positionEvent);
  return {
    success: false,
    message
  };
};

export default onPositionFailed;